import React, { useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import EmployeeAttendanceCalendar from '../Attendance/EmployeeAttendanceCalendar';
import WebClockCard from '../Attendance/WebAttendance/WebClockCard';
import WebAttendanceHistory from '../Attendance/WebAttendance/WebAttendanceHistory';
import { getCurrentCycle } from '../../utils/attendanceCycle';

/**
 * Employee's own attendance dashboard. Renders the Web Attendance punch card
 * and history on top, followed by the rich cycle/month/year calendar layout.
 */
const AttendanceEmp = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const authData = useMemo(() => {
    try { return JSON.parse(localStorage.getItem('authData')); } catch { return null; }
  }, []);
  const employeeNo = authData?.employee_no;

  if (!employeeNo) {
    return (
      <Box sx={{ mt: 10, textAlign: 'center' }}>
        <Typography color="text.secondary">Please sign in to view your attendance.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ pb: { xs: 4, md: 2 }, mt: { xs: -0.5, md: -1.5 } }}>
      {/* Web Attendance Punch & Break Controls */}
      <WebClockCard onActionComplete={() => setRefreshKey((k) => k + 1)} />

      {/* Web Attendance Past Sessions & Regularizations */}
      <WebAttendanceHistory refreshKey={refreshKey} />

      {/* Standard monthly attendance calendar */}
      <EmployeeAttendanceCalendar
        variant="page"
        employeeNo={employeeNo}
        mode="cycle"
        cycle={getCurrentCycle().cycle}
      />
    </Box>
  );
};

export default AttendanceEmp;
